import React from 'react';
import { Button, Accordion } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import PaymentMethodSelected from './PaymentMethodSelected';
import OrderMobile from '../order/OrderMobile';
import Checkbox from '../../../core/components/forms/Checkbox';
import { BUY_FORM_TERMS_FIELD } from '../../reducers/features/buy';

const PaymentInfo = ({ tickets, buyInputs, onSubmitPayment, onCheckboxChange, locale }) => (
    <div>
        <div className="bg-white rounded">
            <Accordion defaultActiveKey={['0']} alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <span className="d-block mb-3 w-100">
                            <span className="h4">
                                <FormattedMessage id="cart_payment_type_and_billing"/>
                            </span>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="payment-method">
                            <PaymentMethodSelected/>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
        <div className="mb-4"/>
        <Checkbox
            controlId={BUY_FORM_TERMS_FIELD}
            checked={buyInputs[BUY_FORM_TERMS_FIELD].value}
            label={<>
                <FormattedMessage id="sell_agree_with"/>&nbsp;
                <Link to={`/${locale}/show/termeni-si-conditii`} className="text-decoration-none" target="_blank">
                    <FormattedMessage id="sell_terms_and_conditions"/>
                </Link>
            </>}
            errorMessage={buyInputs[BUY_FORM_TERMS_FIELD].errorMessage}
            onChange={(e) => onCheckboxChange(e.target.checked)}
            isInvalid={!buyInputs[BUY_FORM_TERMS_FIELD].isValid}
        />
        <div className="d-grid">
            <div className="action-button-payment">
                <OrderMobile open={false} tickets={tickets} />
                <Button size="lg" type="submit" disabled={false} onClick={onSubmitPayment}>
                    <FormattedMessage id="cart_buy_tickets"/>
                </Button>
            </div>
        </div>
    </div>
);

export default PaymentInfo;
